import type { FaireProductEntity } from "../../entity_types/product";

export const p_atkb5k6yqp: FaireProductEntity = {
  token: "p_atkb5k6yqp",
  type: "product",
  name: "Iced Coffee Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/62c2b64c158ace2445790068c66cf84464f6fd51d26c870e382527da50b3d655.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/56340e034be8035666639aa8ea884f52886fa673120f2d8a55a6c3859510c0b5.jpeg",
    "https://cdn.faire.com/fastly/f0356d46e4ddd12e7ce3ea3012dfe753fb0d6a0e925ce387ccfcaf74d8948f4b.jpeg",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a small connection. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes® bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes® have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:08.692Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
